<template>
  <div class="pad" v-html="articalText"></div>
</template>

<script>


export default {
    name: 'agreeMentCard',
    components: {
        
    },
    data () {
        return {
            base_port:'//crmsam.jd.com/union',
            articalText:''
        }
    },
    mounted () {
        let Id = this.$route.query.id; 
        if(Id){
            this.unionAccreditStatement(Id)
        }else{
            this.jdAccreditStatement()
        }     
        
    },
    methods:{
        jdAccreditStatement(){ //京东平台授权声明查询
            let url = this.base_port + '/getPlatformAgreement';
            this.$axios.get(url)
            .then(res => {
                if(res.data.code == 200){
                  this.articalText = res.data.data;
                  this.articalText.replace(' " ',' ')
                }else{
                    //this.showTip(res.data.message)
                }
            })
        }, 
        unionAccreditStatement(id){ //联合品牌会员授权协议
            let url = this.base_port + '/getBrandsAgreements?brandIds=[' + id+ "]";
            this.$axios.get(url)
            .then(res => {
                if(res.data.code == 200){
                    let data = res.data.data;
                    this.articalText = data[id];
                    console.log(this.articalText)
                    this.articalText.replace(' " ',' ')
                }else{
                    //this.showTip(res.data.message)
                }
            })
        }    
    }
}
</script>

<style lang="scss" scoped>
.pad{
    padding:0 9px;    
    color: #333333;
}

@media (max-width: 1000px){
    .pad{
      font-size: 12px;
      line-height: 18px;
    }
}

</style>

